"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiMiddleware = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var actions = _interopRequireWildcard(require("./apiActions"));

var _Api = require("./Api");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var makeApiCall = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(store, action) {
    var apiName, apiReference, apiSettings, endpointName, options, endpoint, result;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiName = action.apiName, apiReference = action.apiReference, apiSettings = action.apiSettings, endpointName = action.endpointName, options = (0, _objectWithoutProperties2.default)(action, ["apiName", "apiReference", "apiSettings", "endpointName"]);
            endpoint = _Api.apiServices.getEndpoint({
              apiReference,
              endpointName
            });
            _context.next = 4;
            return endpoint.call(_objectSpread(_objectSpread({}, options), {}, {
              apiSettings
            }));

          case 4:
            result = _context.sent;
            store.dispatch(actions.apiCallResult({
              apiName,
              apiReference,
              apiSettings,
              endpointName,
              result,
              requestOptions: options
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function makeApiCall(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var apiMiddleware = function apiMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type !== actions.API_CALL_REQUESTED) {
        return next(action);
      }

      makeApiCall(store, action);
      return next(action);
    };
  };
};

exports.apiMiddleware = apiMiddleware;